<!-- Loading -->
<div class="pub-loading" *ngIf="loading">
  <div class="pub-spinner"></div>
</div>

<!-- Error -->
<div class="pub-error" *ngIf="error">
  <h2>{{ error }}</h2>
  <a routerLink="/">Volver al inicio</a>
</div>

<!-- Business Profile -->
<div class="pub-container" *ngIf="business && !loading">

  <!-- Cover -->
  <div class="pub-cover" [style.backgroundImage]="business.cover_image_url ? 'url(' + resolveImg(business.cover_image_url) + ')' : ''">
    <div class="pub-cover-overlay">
      <div class="pub-status" [class.open]="business.is_open">
        {{ business.is_open ? 'Abierto' : 'Cerrado' }}
      </div>
    </div>
  </div>

  <!-- Header -->
  <div class="pub-header">
    <div class="pub-logo" *ngIf="!business.logo_url">{{ business.name[0] }}</div>
    <img *ngIf="business.logo_url" [src]="resolveImg(business.logo_url)" [alt]="business.name" class="pub-logo-img">
    <div class="pub-info">
      <h1 class="pub-name">{{ business.name }}</h1>
      <p class="pub-type" *ngIf="business.business_type">{{ business.business_type }}</p>
      <p class="pub-address" *ngIf="business.address">{{ business.address }}<span *ngIf="business.city">, {{ business.city }}</span></p>
    </div>
  </div>

  <!-- Services -->
  <div class="pub-services" *ngIf="serviceLabels.length > 0">
    <span class="pub-service-chip" *ngFor="let label of serviceLabels">{{ label }}</span>
  </div>

  <!-- Main action: Ver carta -->
  <div class="pub-actions">
    <button class="pub-action-btn primary" *ngIf="menuAvailable" (click)="openMenu()">
      Ver carta y pedir
    </button>
    <button class="pub-action-btn primary" *ngIf="!menuAvailable && !menuLoading">
      Carta no disponible
    </button>
    <button class="pub-action-btn" *ngIf="business.phone" (click)="callBusiness()">
      Llamar
    </button>
    <button class="pub-action-btn" *ngIf="business.address" (click)="getDirections()">
      Como llegar
    </button>
  </div>

  <!-- Login hint -->
  <div class="pub-login-hint" *ngIf="!isLoggedIn">
    <button class="pub-login-btn" (click)="goToLogin()">Iniciar sesion para enviar pedidos</button>
  </div>

  <!-- Description -->
  <div class="pub-section" *ngIf="business.description">
    <h3>Sobre nosotros</h3>
    <p>{{ business.description }}</p>
  </div>

  <!-- Hours -->
  <div class="pub-section" *ngIf="formatHours().length > 0">
    <h3>Horario</h3>
    <div class="pub-hours">
      <div class="pub-hour-row" *ngFor="let h of formatHours()">{{ h }}</div>
    </div>
  </div>

  <!-- Loading menu -->
  <div class="pub-section" *ngIf="menuLoading">
    <div class="pub-menu-loading">
      <div class="pub-spinner"></div>
      <span>Cargando carta...</span>
    </div>
  </div>

  <!-- Footer -->
  <div class="pub-footer">
    <img src="assets/logo.png" alt="BarClik" class="pub-footer-logo">
    <span>Powered by BarClik</span>
  </div>
</div>
